import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable } from 'rxjs';
import { ProjectReadinessDashboard } from '../models/project-readiness.models';

@Injectable({
  providedIn: 'root'
})
export class ProjectReadinessService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  getProjectReadinessDashboard(projectId: string): Observable<ProjectReadinessDashboard> {
    return this.#http.getData<ProjectReadinessDashboard>(`${this.baseUrl}/project-readiness/${projectId}`, {
      showLoader: true,
      showMessage: false
    });
  }
}
